import styled from 'styled-components'

export const SingleTaskContent = styled.div`
  background: #fff;
  border-top-left-radius: 16px;
  height: calc(100vh - 130px);
  overflow-y: hidden;
  display: grid;
  grid-auto-rows: 1fr;
`
